export const getFullName = (entity = {}, fallback = '') => {
  if (!entity) return fallback;

  const parts = [entity.firstName, entity.lastName]
    .map((part) => (typeof part === 'string' ? part.trim() : ''))
    .filter(Boolean);

  if (parts.length > 0) {
    return parts.join(' ');
  }

  if (typeof entity.name === 'string' && entity.name.trim()) {
    return entity.name.trim();
  }

  if (typeof entity.email === 'string' && entity.email.trim()) {
    return entity.email.trim();
  }

  return fallback;
};

export const getInitials = (entity = {}, fallback = '?') => {
  const firstName =
    typeof entity?.firstName === 'string' ? entity.firstName.trim() : '';
  const lastName =
    typeof entity?.lastName === 'string' ? entity.lastName.trim() : '';

  if (firstName || lastName) {
    return `${firstName.charAt(0)}${lastName.charAt(0)}`.toUpperCase() || fallback;
  }

  const source = getFullName(entity, '');
  if (source) {
    const parts = source.split(/\s+/).filter(Boolean);
    if (parts.length >= 2) {
      return `${parts[0].charAt(0)}${parts[1].charAt(0)}`.toUpperCase();
    }
    return source.slice(0, 2).toUpperCase();
  }

  return fallback;
};
